import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { getPatient } from "~/api/patients";
import { PageWrapper } from "~/components";
import { BloodOxygenSaturationDetailView } from "~/components/Patient/Health/components/BloodOxygenSaturation";

export const BloodOxygenSaturationDetail = () => {
  const { id } = useParams();

  const { data: patientData } = useQuery({
    queryFn: () => getPatient(Number(id)),
    queryKey: ["getPatient", { id: Number(id) }],
    enabled: !!id,
  });

  return (
    <PageWrapper>
      {patientData && (
        <div className="container mx-auto min-h-screen gap-10 p-4">
          <BloodOxygenSaturationDetailView
            patientId={patientData.data.id}
            patientName={patientData.data.name + " " + patientData.data.surname}
          />
        </div>
      )}
    </PageWrapper>
  );
};
